import React from 'react'

const NoContentBanner = ({ text = 'Content Will Be Upload Soon!' }) => {
  return (
    <div className="bg-white rounded-lg py-8 lg:py-14 px-6 flex flex-col items-center justify-center space-y-10 font-ibm w-full">
      <img
        src="https://s3.brilliant.com.bd/blog-bucket/fileavatar/f090c325-0456-4312-a00b-a0241b7c5773.png"
        alt="no-content"
        className="w-100 lg:w-125 aspect-auto"
      />
      <p className="text-xl md:text-2xl lg:text-3xl font-medium text-center">{text}</p>
    </div>
  )
}

export default NoContentBanner
